export default async function waitForGlobal(key, timeout = 30_000) {
    return new Promise((resolve, reject) => {
        const intervalId = setInterval(() => {
            if (key in window) {
                clearInterval(intervalId);
                resolve();
            }
        }, 10);
        setTimeout(() => {
            clearInterval(intervalId);
            reject();
        }, timeout);
    });
}
